<!-- 
  详情页 - 批次信息
  props:
    id: 产品
  emit: 
    openDetail: 打开详情页
 -->
<template>
  <div class="batch-tab">
    <h1 v-if="specArray.length>1" class="theme"><i></i><span>产品规格</span></h1>
     <ul v-if="specArray.length>1" class="productCon listCPGG">
        <li v-for="(spec,index) in specArray" 
         :class="{active:index === tabNum}"
         @click="tabLi(spec.id,index)">
          {{spec.specification}}
        </li>
     </ul>
     <h1 class="theme"><i></i><span>批次信息</span></h1>
      <el-table
        border
        :data="tableData"
        :row-class-name="setClassName"
        style="width: 95%">
        <el-table-column
          v-if="haveExpand"
          type="expand"
          width="40">
          <template slot-scope="scope">
            <el-table :data="scope.row.warehouseArray" style="width: 100%">
              <el-table-column
                prop="warehouseName"
                label="仓库名称"
               >
              </el-table-column>
              <el-table-column
                prop="num"
                label="数量"
                width="180">
              </el-table-column>
              <el-table-column
                prop="cost"
                label="批次成本（元）"
                v-show="haveCost"
                width="180">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          label="批次号"
          width="200">
          <template slot-scope="scope">
            {{scope.row.batch}}
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="200">
          <template slot-scope="scope">
            {{scope.row.totalNum}}
          </template>
        </el-table-column>
        <el-table-column
          label="批次成本（元）"
          v-show="haveCost"
          width="200">
          <template slot-scope="scope">
            {{scope.row.cost}}
          </template>
        </el-table-column>
        <el-table-column
          label="储存仓库"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.warehouseArray.length > 1">
              {{scope.row.warehouseArray.length + '个仓库'}}
            </span>
            <span v-else>
              {{scope.row.warehouseArray[0].warehouseName}}
            </span>
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as api from 'src/api'
export default {
  created () {
    this.getTabCon()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      // total: 0,
      // pageSize: 10,
      // currentPage: 1,
      // spaceProId: '', // 选中的规格产品id
      specArray: [], // 规格数组
      tabNum: 0, // 多规格当前选中索引
      tableData: [], // 表格数据数组
      haveExpand: false, // 判断是否需要展开列
      haveCost: 0 // 是否展示成本
    }
  },
  methods: {
    // 获取接口
    getTabCon () {
      let url = `/productApi/getChildProductList.html`
      let params = {
        productId: this.id
      }
      api.post(url, params, (data) => {
        this.specArray = data.childProductList // 规格数组
        if (data.childProductList.length === 1 || data.childProductList[0]) {
          let id = data.childProductList[0].id
          this.getTableList(id)
        }
      })
    },

    // 多规格点击tab
    tabLi (id, index) {
      this.tabNum = index
      this.spaceProId = id
      this.getTableList(id)
    },

    // 请求表格数据
    getTableList (id) {
      this.haveExpand = false
      let url = `/productStock/getBatchList.html`
      let params = {
        productId: id,
        page: this.currentPage,
        pageSize: this.pageSize
      }
      api.post(url, params, (data) => {
        this.tableData = data.resultArray

        // 用来判断表格是否需要有展开这一列
        this.tableData.map((item) => {
          if (item.warehouseArray.length > 1) {
            this.haveExpand = true
          }
          // 成本
          if (item.cost) {
            this.haveCost = 1
          }
        })
      })
    },

    // 展开图标隐藏
    setClassName ({row, index}) {
      if (row.warehouseArray.length > 1) {
        return ''
      } else {
        return 'hideExpand'
      }
    }

  }
}
</script>
<style lang="less">
  .batch-tab{
    .el-table{margin: 15px auto;}
    .hideExpand .el-table__expand-column .cell{display:none;}
  }
</style>
<style lang="less" scoped>
  .batch-tab{
    padding:0 15px;
    .theme{background:#F1F6FE;line-height: 30px;font-size:13px;}
    .theme i{display:inline-block;width:8px;height:8px;background:#FF943E;margin:0 10px;}
    .productCon{
      margin:15px 0 0;
      margin-left: 28px;
      display: flex;
      flex-wrap: wrap;
      &.listCPGG li{padding:10px 10px;border:1px solid #ccc;cursor: pointer;
        margin-right:15px;border-radius: 2px;margin-bottom: 10px;}
      &.listCPGG li.active{border:1px solid #FF943E;background:#FF943E;color:#fff;}
    }
    .pagination-wrapper{width:100%;padding-top: 20px;}
    .pagination-wrapper .el-pagination {float:right;}
  }
</style>


// WEBPACK FOOTER //
// batch-tab.vue?4ff0a98b